import { render, staticRenderFns } from "./Introduccion.vue?vue&type=template&id=1b7cc904&scoped=true"
import script from "./Introduccion.vue?vue&type=script&lang=js"
export * from "./Introduccion.vue?vue&type=script&lang=js"
import style0 from "./Introduccion.vue?vue&type=style&index=0&id=1b7cc904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7cc904",
  null
  
)

export default component.exports